import React, { useRef } from "react";
import { Link } from "react-router-dom";

const ENVIRONNEMENT = process.env.REACT_APP_NODE_ENV;

export const initiales = (user = {}) =>
  [user.firstname, user.lastname]
    .map((partie) => (partie ? String(partie).trim().charAt(0).toUpperCase() : ""))
    .join("");

// Pied du menu : bouton compte (avatar, nom, rôle) et son menu (Mon compte,
// Déconnexion, environnement hors production). Remplace l'ancienne barre haute.
const CompteMenu = ({ user = {}, libelleRole = "", ouvert, onBasculer, onDeconnexion }) => {
  const refBouton = useRef(null);
  const nom = [user.firstname, user.lastname].filter(Boolean).join(" ");
  const monogramme = initiales(user) || "?";

  const surClavier = (evenement) => {
    if (evenement.key === "Escape" && ouvert && refBouton.current) refBouton.current.focus();
  };

  return (
    <div className="menu-lateral__pied" onKeyDown={surClavier}>
      <button
        ref={refBouton}
        type="button"
        className="menu-lateral__compte"
        aria-haspopup="true"
        aria-expanded={ouvert}
        aria-controls="menu-compte"
        onClick={onBasculer}
      >
        <span className="menu-lateral__avatar" aria-hidden="true">
          {monogramme}
        </span>
        <span className="menu-lateral__compte-texte">
          <span className="menu-lateral__compte-nom">{nom}</span>
          {libelleRole && <span className="menu-lateral__compte-role">{libelleRole}</span>}
        </span>
        <i className="fa fa-chevron-up" aria-hidden="true" />
      </button>
      <div id="menu-compte" className="menu-lateral__menu-compte" hidden={!ouvert}>
        <div className="menu-lateral__menu-compte-entete">
          <span className="menu-lateral__avatar" aria-hidden="true">
            {monogramme}
          </span>
          <div>
            <b>{nom}</b>
            {libelleRole && <span className="menu-lateral__role">{libelleRole}</span>}
          </div>
        </div>
        <Link to="/me">
          <i className="fa fa-user-circle" aria-hidden="true" />
          Mon compte
        </Link>
        <button type="button" onClick={onDeconnexion}>
          <i className="fa fa-power-off" aria-hidden="true" />
          Déconnexion
        </button>
        <div className="menu-lateral__env">
          <span>ESPOAR · Caf 974</span>
          {ENVIRONNEMENT && ENVIRONNEMENT !== "production" && <span>Environnement : {ENVIRONNEMENT}</span>}
        </div>
      </div>
    </div>
  );
};

export default CompteMenu;
